var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"/"}},[_c('b-img',{staticClass:"d-none d-md-inline-block mr-3",attrs:{"src":require("@/assets/icon.png"),"width":"100","height":"75","alt":"logo"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }